import { __assign } from "tslib";
// convert flat folder array to a { folder, subfolders }[] array based on parentId attr
export var convertToFoldersWithSubfolders = function (folders) {
    return (folders
        // leave only top level folders
        .filter(isTopLevelFolder)
        // attach subfolders
        .map(function (folder) { return (__assign(__assign({}, folder), { subfolders: folder.hasSubfolders === false // little perf improvement - don't filter long lists if not needed
            ? []
            : folders.filter(function (potentialSubfolder) {
                return potentialSubfolder.parentId === folder.folderId;
            }) })); }));
};
export var isTopLevelFolder = function (folder) { return !folder.parentId; };
export var filterTopLevelFolders = function (folders) {
    return folders.filter(isTopLevelFolder);
};
//# sourceMappingURL=folders.js.map